export default function isMobileView(): boolean {
  return window.matchMedia('(max-width: 768px)').matches;
}
